import securityProfileService from "@/services/bytepro/securityProfile.service";
// import moment from 'moment';

export const securityProfileApi = {
  namespaced: true,
  state: {},
  getters: {},
  actions: {
    getSecurityProfiles({ commit }) {
      return securityProfileService.getSecurityProfiles().then(
        (resp) => {
          commit(
            "dummyConsole",
            "securityProfileService.getSecurityProfiles - success"
          );
          return Promise.resolve(resp);
        },
        (error) => {
          commit(
            "dummyConsole",
            "securityProfileService.getSecurityProfiles - error"
          );
          return Promise.reject(error);
        }
      );
    },
    getSecurityProfile({ commit }, securityProfileId) {
      return securityProfileService.getSecurityProfile(securityProfileId).then(
        (resp) => {
          commit(
            "dummyConsole",
            "securityProfileService.getSecurityProfile - success"
          );
          return Promise.resolve(resp);
        },
        (error) => {
          commit(
            "dummyConsole",
            "securityProfileService.getSecurityProfile - error"
          );
          return Promise.reject(error);
        }
      );
    },
  },
  mutations: {
    dummyConsole(state, obj) {
      console.log(obj);
    },
  },
};
